module.exports = __webpack_public_path__ + "img/custom-reports-1.7fdb4e82.png";